module.exports = __webpack_public_path__ + "static/about-384d25cf3a5d43f425359ebe280d06d3.png";